import SparkMD5 from 'spark-md5';

/**
 * MD5 of the blob contents as lowercase hex (32 characters).
 *
 * @param {Blob} blob
 * @returns {Promise<string>}
 */
export async function computeMd5HexFromBlob(blob) {
  const buffer = await blob.arrayBuffer();
  return SparkMD5.ArrayBuffer.hash(buffer);
}
